<template>
  <div>
    <v-dialog name="dialog" />
    <div class="admin_title">机构角色管理</div>
    <div class="gj_top_class">
      <a @click="delUsers(selected)" class="btn" style="background: #ff3633; padding-left: 23px;">批量删除</a>
      <a @click="edit('')" class="btn btn_add">新增角色</a>
    </div>
    <div class="gj_list"  style="min-height:670px;">
      <el-table v-if="tableData.data && tableData.data.length > 0"
                :data="tableData.data" stripe border @selection-change="updateSelected"
                style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="name" label="角色名称" sortable fixed>
        </el-table-column>
        <el-table-column
          prop="nameEn" label="角色英文" sortable>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <a title="编辑" class="el-icon-edit" @click="edit(scope.row.id)" style="cursor: pointer;"></a>
            <a title="删除" class="el-icon-delete" @click="del(scope.row)" style="cursor: pointer;"></a>
            <a title="用户列表" class="el-icon-my-admin" @click="distribute(scope.row)" style="cursor: pointer;"></a>
          </template>
        </el-table-column>
      </el-table>
      <h5 class="none_ts" v-if="tableData.data.length == 0">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
    </div>
    <div class="zy_list_bottom mtf30">
      <dl>
        <dt v-if="pages> 0">共{{cnt}}条记录</dt>
        <dd v-if="pages >0">
          <paginate v-if="pages > 0" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text></paginate>
        </dd>
      </dl>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
  import api from '@/api/index'
  import config from '@/config/index'
  import utils from '@/utils'
  import Paginate from 'vuejs-paginate'
  import { mapState } from 'vuex'
  export default {
    components: { Paginate },
    mounted () {
      this.search(this.filters)
    },
    data () {
      return {
        lists: [],
        selected: [], // 选择的列表
        filters: {
          pageNo: 1,
          pageSize: 9,
          isOrg: '1'
        },
        pages: 0,
        cnt: 0,
        tableData: {
          data: []
        },
        prefix: this.$route.meta.prefix || ''
      }
    },
    computed: {
    },
    methods: {
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: utils.debounce(() => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }, 1000)
            },
            {
              title: '取消'
            }
          ]
        })
      },
      updateSelected (val) {
        this.selected = val
      },
      clickCallback (pageNum)  {
        this.filters.pageNo = pageNum
        this.search(this.filters)
      },
      delUsers (items) {
        if (items.length > 0) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              var ids = utils.arr2str(utils.grabVal(items, 'id'))
              api.get(config.bylBaseCenterPath, '/role/delete/batch', {ids: ids}, function (r) { // 正常
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        } else {
          this.$toasted.show('没有删除项')
        }
      },
      edit (id) {
        if (id == '') {
          id = 'void'
        }
        this.$router.push({path: this.prefix + '/org/orgrole/'+ id})
      },
      distribute (item) {
        this.$router.push({path: this.prefix + '/org/orgrole/distribute/' + item.id})
      },
      del (item) {
        if (item) {
          var that = this
          this.confirmBox({
            title: '删除',
            text: '确认删除吗?',
            yes: function () {
              api.get(config.bylBaseCenterPath, '/role/delete/batch', {ids: item.id}, function (r) { // 正常
                that.$toasted.show('删除成功')
                that.search(that.filters)
                that.$modal.hide('dialog')
              })
            }
          })
        }
      },
      search (filters) {
        if (!filters) { filters = {} }
        var that = this
        api.post(config.bylBaseCenterPath, '/role/roles', filters, function (r) { // 正常
          that.pages = Math.ceil(r.cntData / that.filters.pageSize)
          that.tableData.data = (r.data) ? r.data : []
          that.cnt = r.cntData
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/page/byl/org/role/list.vue